import React from 'react';
import PropTypes from 'prop-types';

import IssueItem from '@/components/IssueItem/IssueItem';

import styles from './IssueList.module.sass';

const IssueList = ({ list }) => (
  <section className={styles.issueList}>
    {list?.map((issue) => (
      <article className={styles.postItem} key={issue.slug}>
        <IssueItem {...issue} />
      </article>
    ))}
  </section>
);

export default IssueList;

IssueList.propTypes = {
  list: PropTypes.array,
  pageInfo: PropTypes.shape({
    hasNextPage: PropTypes.bool,
    endCursor: PropTypes.string,
  }),
};
